import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { InvoiceEnums } from 'src/app/enum/invoice-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoiceConceptModel } from 'src/app/models/invoicing/invoice-concept.model';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceDiscountConceptTableModel } from 'src/app/models/tables/invoicing/Invoice-discount-concept-table.model';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { InvoiceConceptService } from 'src/app/services/invoicing/invoice-concept.service';
import { InvoiceDetailService } from 'src/app/services/invoicing/invoice-detail.service';
import { ChargeAccountConceptService } from 'src/app/services/others/charge-account-concept.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-list-charge-account-concept',
  templateUrl: './list-charge-account-concept.component.html',
  styleUrls: ['./list-charge-account-concept.component.scss'],
  standalone: false
})
export class ListChargeAccountConceptComponent implements OnInit {

  ascendant: boolean = true;
  chargeAccountConceptModel: InvoiceConceptModel = new InvoiceConceptModel();
  chargeAccountModel: InvoiceModel = new InvoiceModel();
  columnSort: string | null = null;
  data: PagedResponseModel<InvoiceDiscountConceptTableModel> = new PagedResponseModel<InvoiceDiscountConceptTableModel>();
  disabledActions: boolean = false;
  displayedColumns: string[] = ['index', 'conceptInvoicingCode', 'conceptInvoicingName', 'value', 'discountRate', 'discountValue'];
  formChargeAccountConcept: FormGroup = new FormGroup({});
  header: ColumnResponseModel[] = [];
  isFormView: boolean = false;
  limit: number = 10;
  listConceptInvoicing: any[] = [];
  page: number = 1;
  permissionUpdatable: boolean = false;
  selectedRow: Array<InvoiceConceptModel> = Array<InvoiceConceptModel>();
  suscription: Subscription;
  tableActions: TableAction[] = [];
  updateChargeAccount: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private invoiceDetailService: InvoiceDetailService,
    private chargeAccountConceptService: ChargeAccountConceptService,
    private invoiceConceptService: InvoiceConceptService,
    private toastHandlerService: ToastHandlerService,
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef) {
  }

  async ngOnInit(): Promise<void> {
    this.validateForm(new InvoiceConceptModel());
    await this.getColumns();
    await this.getlistConceptInvoicing();

    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.chargeAccountModel = inputs.chargeAccountModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
      this.disabledActions = inputs.disabledForm;
    });

    await this.getInvoiceConceptsByInvoiceIdWithPagination();
    this.tableActions = this.getDefaultActions();
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async cancel() {
    this.chargeAccountConceptModel = new InvoiceConceptModel();
    this.validateForm(this.chargeAccountConceptModel);
    this.isFormView = false;
  }


  changeDiscountRate() {
    const form = this.formChargeAccountConcept;

    const discountRate = form.get('discountRate')?.value ?? 0;
    const value = form.get('value')?.value ?? 0;

    if (discountRate > 100) {
      this.toastHandlerService.showToast(
        'warning',
        'El porcentaje del descuento no puede ser superior a 100.',
        'Atención'
      );

      this.formChargeAccountConcept.get("discountRate")?.patchValue(0);
      this.formChargeAccountConcept.get("discountValue")?.patchValue(0);
      return;
    }

    form.patchValue({
      discountRate,
      discountValue: discountRate > 0 ? (value * discountRate) / 100 : 0
    });
  }

  changeDiscountValue() {
    const form = this.formChargeAccountConcept;

    const discountValue = form.get('discountValue')?.value ?? 0;
    const value = form.get('value')?.value ?? 0;

    if (discountValue > value) {
      this.toastHandlerService.showToast(
        'warning',
        'El valor del descuento no puede ser superior al valor del Concepto.',
        'Atención'
      );
      this.formChargeAccountConcept.get("discountRate")?.patchValue(0);
      this.formChargeAccountConcept.get("discountValue")?.patchValue(0);
      return;
    }

    const discountRate = discountValue > 0 ? (discountValue / value) * 100 : 0;

    form.patchValue({
      discountRate,
      discountValue
    });
  }

  close() {
    const data: ModalObjectType = {};
    data.params = { updateChargeAccount: this.updateChargeAccount };
    this.ref.close(data);
  }

  async getColumns() {
    try {
      this.header = await firstValueFrom(this.chargeAccountConceptService.getColumnsForChargeAccountDiscountConceptAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getConceptInvoicingCodeNameById(conceptInvoicingId: number): Promise<{ code: string; name: string }> {
    try {
      return await firstValueFrom(this.invoiceConceptService.getConceptInvoicingCodeNameById(conceptInvoicingId));
    } catch (error) {
      console.error('Error al buscar el nombre del concepto.', error);
    }
    return { code: "", name: "string" };
  }

  getDefaultActions(): TableAction[] {
    if (this.chargeAccountModel.invoiceStateId == InvoiceEnums.abierta) {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          action: 'edit'
        }
      ];
    } else {
      return [];
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getInvoiceConceptsByInvoiceIdWithPagination() {
    try {
      this.data = await firstValueFrom(this.invoiceConceptService.getInvoiceConceptsByInvoiceIdWithPagination(this.page, this.limit, this.columnSort, this.ascendant,
        this.chargeAccountModel.invoiceId));
    } catch (error) {
      console.error('Error al buscar los conceptos.', error);
    }
  }

  async getlistConceptInvoicing() {
    try {
      this.listConceptInvoicing = await firstValueFrom(this.invoiceDetailService.getAllConceptInvoicingForSelectAsync());
    } catch (error) {
      console.error('Error al obtener la lista de conceptos.', error);
    }
  }

  async onAction(event: { action: string, item?: InvoiceDiscountConceptTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      try {
        this.chargeAccountConceptModel = await firstValueFrom(this.chargeAccountConceptService.getChargeAccountConceptById(event.item.id));
        this.validateForm(this.chargeAccountConceptModel);
        this.isFormView = true;
      } catch (error) {
        console.error('Error to edit repair:', error);
      }
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getInvoiceConceptsByInvoiceIdWithPagination();
  }

  async send() {
    this.validateFormControls();
    if (this.formChargeAccountConcept.valid) {
      const modelInvoiceConcept = this.setForm();
      try {
        await firstValueFrom(this.invoiceConceptService.saveGeneralDiscount(modelInvoiceConcept));
        this.getInvoiceConceptsByInvoiceIdWithPagination();
        this.validateForm(new InvoiceConceptModel);
        this.updateChargeAccount = true;
        this.isFormView = false;
        this.toastHandlerService.showToast('success', 'El concepto se modifico exitosamente.', '');
      } catch (error) {
        console.error('Error al guardar el descuento general', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  setForm(): any {
    this.chargeAccountConceptModel.invoiceConceptId = this.formChargeAccountConcept.get("conceptInvoicingId")?.value;
    this.chargeAccountConceptModel.conceptInvoicingId = this.formChargeAccountConcept.get("conceptInvoicingId")?.value;
    this.chargeAccountConceptModel.discountRate = this.formChargeAccountConcept.get("discountRate")?.value;
    this.chargeAccountConceptModel.discountValue = this.formChargeAccountConcept.get("discountValue")?.value;
    return this.chargeAccountConceptModel;
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      discountRate: {
        min: 'Debe ingresar un descuento válido'
      },
      discountValue: {
        min: 'Debe ingresar un valor descuento válido'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formChargeAccountConcept.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(invoiceConcept: InvoiceConceptModel) {
    this.formChargeAccountConcept = this.formBuilder.group({
      conceptInvoicingId: [invoiceConcept.conceptInvoicingId, [Validators.required]],
      value: [invoiceConcept.value, [Validators.required]],
      discountRate: [invoiceConcept.discountRate, [Validators.required, Validators.min(0)]],
      discountValue: [invoiceConcept.discountValue, [Validators.required, Validators.min(0)]],
    });

    this.formControlStateService.setControlState(this.formChargeAccountConcept, ['conceptInvoicingId', 'value'], false);
  }

  validateFormControls() {
    Object.keys(this.formChargeAccountConcept.controls).forEach((key) => {
      const control = this.formChargeAccountConcept.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
